import React from 'react';
import { PageTitle, MainDashboardPage } from 'components';
import { useTranslation } from 'react-i18next';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { NewFeatureBanner } from 'components/NewFeatureBanner';
import { SpecialOfferPage } from './SpecialOfferPage';

export const SpecialOfferDashboardPage = () => {
  const { t } = useTranslation();
  return (
    <AnalyticsCategoryProvider category={Categories.SPECIAL_OFFER}>
      <PageTitle title={t('billing.specialOffer.shortTitle')} />
      <MainDashboardPage>
        <NewFeatureBanner />
        <SpecialOfferPage />
      </MainDashboardPage>
    </AnalyticsCategoryProvider>
  );
};
